import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ListView from './components/list-view'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput, Button, Checkbox, Select } from 'elements'
import { liveVisitListSelector, liveVisitListStatusSelector, liveVisitListDateSelector, liveVisitListDateStatusSelector, 
          siteListSelector, holdersCountSelector, liveDiscoverySelector, clientConfigDetailsSelector, liveVisitHoldersCountSelector, liveVisitHoldersOnSiteCountSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listLiveVisits, listLiveVisitsDate, getHoldersCount, getHoldersCountOnSite } from 'redux/modules/model/livevisit'
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'
import { listSites, listenToSubscriptions } from 'redux/modules/model/site';
import { getClientConfig } from 'redux/modules/model/client'
import { getActiveHoldersCount } from 'redux/modules/model/holder';

import Timeline, { TodayMarker, TimelineMarkers, TimelineHeaders, DateHeader, SidebarHeader } from 'react-calendar-timeline'
import 'react-calendar-timeline/lib/Timeline.css'
import moment from 'moment-timezone';
import { Avatar, Typography } from '@/elements';
import { PageContentUnderTitle } from 'components'
import ZoneFilter from './components/zone-filter';
import { Empty } from 'antd';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'directory-filter-bar'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const { Title } = Typography;

const predicate = (criteria) => (item) => {
  if (criteria.search) {
    const ucSearch = criteria.search.toUpperCase()
    return item.name.toUpperCase().includes(ucSearch) ||
      item.username.toUpperCase().includes(ucSearch) ||
      item.email.toUpperCase().includes(ucSearch)
  }
  if (!criteria.showAll) {
    return item.active
  }
  return true
}

class RealtimeList extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    listLiveVisits: PropTypes.func.isRequired,
    getHoldersCount: PropTypes.func.isRequired,
    getHoldersCountOnSite: PropTypes.func.isRequired,
    listLiveVisitsDate: PropTypes.func.isRequired,
    logUserTab: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    livevisitList: PropTypes.array.isRequired,
    liveVisitListStatus: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props)
    const visibleTimeStart = moment().startOf("day").valueOf();
    const visibleTimeEnd = moment().startOf("day").add(1, "day").valueOf();
    this.state = {
      search: null,
      siteId: null,
      visibleTimeStart,
      visibleTimeEnd,
      limit: 10,
      offset: 0,
      openCheckin: false,
      queryParams: {
        ...parseQueryString(this.props.location.search),
        showAll: '1'
      }
    }
  }

  groupRenderer = ({ group }) => {
    return <div className="tip">
      <section className="containerr" onClick={() => this.props.history.push(`/directory/${group.id}`)}>
        <div className="one"><Avatar className="image"
          image={group.image}
        /></div>
        <div className="two">
          <p>{group.title}</p>
          <p>{group.id}</p>
        </div>
      </section>

    </div>;
  };

  componentDidMount() {
    const { clientId, listLiveVisits, listLiveVisitsDate, logUserTab, listSites, getClientConfig, getActiveHoldersCount } = this.props
    listSites({ clientId });
    getClientConfig({ targetClientId: clientId })
    getActiveHoldersCount({ clientId });
    const tab = "listLiveVisits"
    // logUserTab({ clientId, tab })
  }

  componentDidUpdate(prevProps, prevState) {
    const { siteId, zoneId, visibleTimeStart, visibleTimeEnd, limit, offset  } = this.state;
    const { sitesList, clientId, getZonesList, zonesList, listLiveVisits, listLiveVisitsDate, listenToSubscriptions, discoveredList, getHoldersCount, getHoldersCountOnSite } = this.props;
    var startTime = new Date();
    startTime.setUTCHours(0,0,0,0);
    var endTime = new Date();
    endTime.setUTCHours(23,59,59,999);
    
    startTime = moment(startTime, 'DD/MM/YYYY').toISOString();
    endTime = moment(endTime, 'DD/MM/YYYY').toISOString();

    startTime = moment(visibleTimeStart).toISOString();
    endTime = moment(visibleTimeEnd).toISOString();

    if (prevProps.discoveredList.length > 0 && discoveredList.length > 0)
      for (var m = 0; m < discoveredList.length; m++) {
        if (prevProps.discoveredList[m] && discoveredList[m])
          if (prevProps.discoveredList[m].detectionTime !== discoveredList[m].detectionTime) {
            listLiveVisitsDate({ clientId, siteId, startTime, endTime, limit, offset })
            getHoldersCount({ clientId, siteId, startTime, endTime })
            getHoldersCountOnSite({ clientId, siteId, startTime })
          }
      }

    if (siteId && prevState.siteId !== siteId) {
      listLiveVisitsDate({ clientId, siteId, startTime, endTime, limit, offset })
      getHoldersCount({ clientId, siteId, startTime, endTime })
      getHoldersCountOnSite({ clientId, siteId, startTime })
      listenToSubscriptions({
        clientId,
        siteId,
        includeLastKnown: true,
      });
    }

    if (visibleTimeStart && prevState.visibleTimeStart !== visibleTimeStart) {
      listLiveVisitsDate({ clientId, siteId, startTime, endTime, limit, offset })
      getHoldersCount({ clientId, siteId, startTime, endTime })
      getHoldersCountOnSite({ clientId, siteId, startTime })
      listenToSubscriptions({
        clientId,
        siteId,
        includeLastKnown: true,
      });
    }
    if (sitesList && sitesList.length > 0 && !siteId) {
      this.handleSiteChange(sitesList[0].siteId);
    }
  }

  setURLHref = (params) => {
    const { history } = this.props
    history.push({
      location: ROUTES.DIRECTORY,
      search: jsonToQueryString(params),
      showAll: params.showAll
    })
  };

  handleSearchChange = e => {
    this.setState({
      search: e.target.value,
    });
    const params = {
      ...parseQueryString(location.search),
      search: e.target.value,
    };
    this.setURLHref(params);
    this.setState({ queryParams: params });
  };

  handleSiteChange = siteId => {
    const newQueryStr = {
      ...this.state.queryParams,
      site: encodeURIComponent(siteId),
    };
    this.setURLHref(newQueryStr);
    this.setState({ queryParams: newQueryStr, siteId });
  };

  handleShowAllSites = () => {
    var siteId = "all"
    const newQueryStr = {
      ...this.state.queryParams,
      site: encodeURIComponent(siteId),
    };
    this.setURLHref(newQueryStr);
    this.setState({ queryParams: newQueryStr, siteId });
  }

  handleActiveChange = (e) => {
    const params = {
      ...this.state.queryParams,
      showAll: e
    }
    this.setURLHref(params)
  }

  onChange = (nextValue) => {
    const zoom = this.state.visibleTimeEnd - this.state.visibleTimeStart;
    this.setState(state => ({
      visibleTimeStart: moment(nextValue).valueOf(),
      visibleTimeEnd: moment(nextValue).valueOf() + zoom
    }));
  }

  onPrevClick = () => {
    const zoom = this.state.visibleTimeEnd - this.state.visibleTimeStart;
    this.setState(state => ({
      visibleTimeStart: state.visibleTimeStart - zoom,
      visibleTimeEnd: state.visibleTimeEnd - zoom
    }));
  };

  onTodayClick = () => {
    this.setState(state => ({
      visibleTimeStart: moment().startOf("day").valueOf(),
      visibleTimeEnd: moment().startOf("day").add(1, "day").valueOf()
    }));
  };

  onNextClick = () => {
    const zoom = this.state.visibleTimeEnd - this.state.visibleTimeStart;
    this.setState(state => ({
      visibleTimeStart: state.visibleTimeStart + zoom,
      visibleTimeEnd: state.visibleTimeEnd + zoom
    }));
  };

  loadLiveVisits = () => {
    const { clientId, listLiveVisitsDate, getHoldersCount, getHoldersCountOnSite } = this.props;
    const { siteId, visibleTimeStart, visibleTimeEnd, limit, offset } = this.state;

    let startTime = moment(visibleTimeStart).toISOString();
    let endTime = moment(visibleTimeEnd).toISOString();

    listLiveVisitsDate({ clientId, siteId, startTime, endTime, limit, offset });
    getHoldersCount({ clientId, siteId, startTime, endTime })
    getHoldersCountOnSite({ clientId, siteId, startTime })
};

  handleLoadMoreNext = () => {
    this.setState(prevState => ({
        offset: prevState.offset + prevState.limit
    }), this.loadLiveVisits);
};

handleLoadMorePrevious = () => {
    this.setState(prevState => ({
        offset: Math.max(prevState.offset - prevState.limit, 0)
    }), this.loadLiveVisits);
};

  render() {
    const { livevisitList, liveVisitListStatus, livevisitListDate, liveVisitListDateStatus, location, sitesList, holdersCountList, discoveredList, clientId, clientConfigDetail, liveVisitHoldersCountList, liveVisitHoldersOnSiteCountList } = this.props
    const {
      queryParams: { zone: zoneId, site: siteId, thermal: thermalId }, visibleTimeStart, visibleTimeEnd, offset, limit
    } = this.state;
    let timeZone = 'Europe/London'
    sitesList.forEach(site => {
      site.siteId === siteId ? timeZone = site.timeZone : 'Europe/London'
    })
    let showCalendar = false
    for(let i=0; i<livevisitListDate.length ;i++){
      if(siteId != livevisitListDate[i].siteId && siteId != "all"){
        showCalendar = false
        break;
      }
      showCalendar = true
    }

    let membersOptionsList = [
      { name: 'show all', id: '1' },
      { name: 'checked in', id: '2' },
      { name: 'checked out', id: '3' }]

    const params = parseQueryString(location.search)
    let search = params.search
    let showAll = location.showAll
    let memberId = location.showAll
    const { view = 'list' } = params
    let groups = []
    let items = []
    var counter = 0
    var todayCounter = 0
    let clientReferences = []
    let checkedinClientReferences = []
    console.log("🚀 ~ RealtimeList ~ livevisitListDate.forEach ~ livevisitListDate:", livevisitListDate)
    livevisitListDate.forEach((liveVisit, i) => {
      if (liveVisit.endTime === null) {
        checkedinClientReferences.push(liveVisit.clientReference)
      }
    })
    if (clientConfigDetail) {
      if (clientConfigDetail.clientId === clientId && clientConfigDetail.liveVisitMergePeriod !== 0) {
        for (let i = livevisitListDate.length - 1; i >= 0; i--) {
          for (let j = i - 1; j >= 0; j--) {
            if (livevisitListDate[i].clientReference === livevisitListDate[j].clientReference && livevisitListDate[i].siteId === livevisitListDate[j].siteId) {
              const currentEndTime = new Date(livevisitListDate[i].endTime);
              const previousStartTime = new Date(livevisitListDate[j].startTime);
              const diffTime = (Math.abs(previousStartTime - currentEndTime)) / 1000;
              if (diffTime < clientConfigDetail.liveVisitMergePeriod) {
                livevisitListDate[j].startTime = livevisitListDate[i].startTime
                livevisitListDate.splice(i, 1);
                break;
              }
            }
          }
        }
      }
    }
    livevisitListDate.forEach((liveVisit, i) => {
      var inputDate = new Date(liveVisit.startTime);

      var todaysDate = new Date();

      var endTime = liveVisit.endTime;
      var colour = '#ff9800'
      if (endTime === null) {
        counter++
        endTime = new Date()
        endTime = moment(endTime).format()
        colour = '#1dc992'
      }
      var startTime = liveVisit.startTime;
      endTime = moment(endTime).tz(timeZone).format()
      startTime = moment(startTime).tz(timeZone).format()

      var inputDate1 = new Date(endTime);

      var found2 = false
      for (var j = 0; j < clientReferences.length; j++) {
        if (clientReferences[j] === liveVisit.clientReference) {
          found2 = true;
          break;
        }
      }
      if (!found2) {
        if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0) ||
          inputDate1.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
          clientReferences.push(liveVisit.clientReference)
          todayCounter++
        }
      }
      if (showAll === '1') {
        var found = false;
        for (var k = 0; k < groups.length; k++) {
          if (groups[k].id == liveVisit.clientReference) {
            found = true;
            break;
          }
        }
        if (!found) {
          if (liveVisit.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
            groups.push({
              id: liveVisit.clientReference,
              title: liveVisit.name,
              stackItems: true,
              image: liveVisit.imagePath,
              tip: liveVisit.clientReference
            })
          }
        }
        items.push({
          id: i,
          group: liveVisit.clientReference,
          title: `${startTime.substr(11, 5)} - ${endTime.toString().substr(11, 5)} - ${siteId === 'all' ? liveVisit.siteId : siteId}`,
          start_time: new Date(startTime),
          end_time: new Date(endTime),
          itemProps: {
            style: {
              background: colour,
              textOverflow: "clip",
              whiteSpace: "nowrap",
              overflow: "hidden"
            }
          }
        })
      } else if (showAll === '2') {
        if (liveVisit.endTime === null) {
          var found = false;
          for (var k = 0; k < groups.length; k++) {
            if (groups[k].id == liveVisit.clientReference) {
              found = true;
              break;
            }
          }
          if (!found) {
            if (liveVisit.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
              groups.push({
                id: liveVisit.clientReference,
                title: liveVisit.name,
                stackItems: true,
                image: liveVisit.imagePath,
                tip: liveVisit.clientReference
              })
            }
          }
          items.push({
            id: i,
            group: liveVisit.clientReference,
            title: `${startTime.substr(11, 5)} - ${endTime.toString().substr(11, 5)} - ${siteId === 'all' ? liveVisit.siteId : siteId}`,
            start_time: new Date(startTime),
            end_time: new Date(endTime),
            itemProps: {
              style: {
                background: colour
              }
            }
          })
        }

      } else if (showAll === '3') {
        if (liveVisit.endTime && !checkedinClientReferences.includes(liveVisit.clientReference)) {
          var found = false;
          for (var k = 0; k < groups.length; k++) {
            if (groups[k].id == liveVisit.clientReference) {
              found = true;
              break;
            }
          }
          if (!found) {
            if (liveVisit.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
              groups.push({
                id: liveVisit.clientReference,
                title: liveVisit.name,
                stackItems: true,
                image: liveVisit.imagePath,
                tip: liveVisit.clientReference
              })
            }
          }
          items.push({
            id: i,
            group: liveVisit.clientReference,
            title: `${startTime.substr(11, 5)} - ${endTime.toString().substr(11, 5)} - ${siteId === 'all' ? liveVisit.siteId : siteId}`,
            start_time: new Date(startTime),
            end_time: new Date(endTime),
            itemProps: {
              style: {
                background: colour
              }
            }
          })
        }
      }

    });
    
    return (
      <div>
        <Row gutter={40} align="middle" justify="center" >
          <Col xs={32} md={16}>
            <ZoneFilter
              onZoneChange={this.handleSiteChange}
              zoneId={siteId}
              zones={sitesList}
              placeholder="Select a site"
              idKey="siteId"
              nameKey="description"
            />
          </Col>
          <Col xs={14} md={8}>
            <Button
              className="all-sites-button"
              type="primary"
              onClick={this.handleShowAllSites}
            >
              All sites
            </Button>
          </Col>
        </Row>
        <Row gutter={40} align="middle" justify="center" >
          <Col xs={32} md={16}>
            <Select
              showSearch
              value={memberId}
              style={{ width: '100%' }}
              placeholder={"Select members"}
              optionFilterProp="children"
              onChange={this.handleActiveChange}
              className="select-members"
            >
              {membersOptionsList.map((membersOption) => (
                <Select.Option value={membersOption['id']} key={membersOption['id']}>
                  {membersOption['name']}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xs={14} md={8}>
            {/* <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} /> */}
          </Col>
        </Row>
        <Row gutter={40} align="middle" justify="center" className="row-counters">
          <Col xs={12} md={7}>
            <button className="unifi-button-counter">
              Total number of members: {holdersCountList.length}
            </button>
          </Col>
          <Col xs={20} md={9}>
            <button className="unifi-button-counter">
              {siteId === 'all' ? `Total members currently in all sites: ${liveVisitHoldersOnSiteCountList}` : `Total members currently on site: ${liveVisitHoldersOnSiteCountList}`}
            </button>
          </Col>
          <Col xs={14} md={8}>
            <button className="unifi-button-counter">
              {siteId === 'all' ? `Total members today in all sites: ${liveVisitHoldersCountList}` : `Total members today: ${liveVisitHoldersCountList}`}
            </button>
          </Col>
        </Row>
        <Row gutter={40} align="middle" justify="center" className="row-dates">
          <Col xs={12} md={7}>
            <DatePicker dateFormat="dd/MM/yyyy" className="unifi-datepicker" selected={visibleTimeStart} onChange={this.onChange} />
          </Col>
          <Col xs={20} md={9}>
          </Col>
          <Col xs={14} md={8} align="middle">
            <Button className="unifi-button-date" onClick={this.onPrevClick}>{"< Prev"}</Button>
            <Button className="unifi-button-date" onClick={this.onTodayClick}>{"Today"}</Button>
            <Button className="unifi-button-date" onClick={this.onNextClick}>{"Next >"}</Button>
          </Col>
        </Row>
        {showCalendar&& groups && items.length !=0 ? <Timeline
          groups={groups}
          items={items}
          visibleTimeStart={visibleTimeStart}
          visibleTimeEnd={visibleTimeEnd}
          groupRenderer={this.groupRenderer}
          sidebarWidth={250}
          lineHeight={70}>
          <TimelineHeaders>
            <SidebarHeader>
              {({ getRootProps }) => {
                return <div className="sidebar" {...getRootProps()}>Members</div>
              }}
            </SidebarHeader>
            <DateHeader unit="primaryHeader" />
            <DateHeader />
          </TimelineHeaders>
          <TimelineMarkers>
            <TodayMarker />
          </TimelineMarkers>
        </Timeline>: <div className="no-holders">
          <Empty 
									description={
										'Hello, it doesn’t look like anyone has been seen here recently. Try selecting a different site or day.'
									}
								/></div>}
                <Row>
                <Col></Col>
                <Col></Col>
                  <Col>
                    <Button className="unifi-button-date2" onClick={this.handleLoadMorePrevious} disabled={offset === 0}>
                      Previous Page
                    </Button>
                    <Button className="unifi-button-date2" onClick={this.handleLoadMoreNext}>
                      Next Page
                    </Button>
                  </Col>
                </Row>
      </div>
    )
  }
}

export const selector = createStructuredSelector({
  livevisitList: liveVisitListSelector,
  liveVisitListStatus: liveVisitListStatusSelector,
  livevisitListDate: liveVisitListDateSelector,
  liveVisitListStatusDate: liveVisitListDateStatusSelector,
  clientConfigDetail: clientConfigDetailsSelector,
  sitesList: siteListSelector,
  holdersCountList: holdersCountSelector,
  liveVisitHoldersCountList: liveVisitHoldersCountSelector,
  liveVisitHoldersOnSiteCountList: liveVisitHoldersOnSiteCountSelector,
  discoveredList: liveDiscoverySelector,
})

export const actions = {
  listLiveVisits,
  listLiveVisitsDate,
  logUserTab,
  listSites,
  getClientConfig,
  getActiveHoldersCount,
  getHoldersCount,
  getHoldersCountOnSite,
  listenToSubscriptions
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(RealtimeList)


// WEBPACK FOOTER //
// ./src/pages/realtime-view/realtime-list/index.js